import React from "react";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {ColumnProps} from "types/models";
import {DataFormField} from "types/models/input-field-type";
import {
  gioiTinhOptions,
  khuKCBOptions,
  loaiKCBOptions,
  trangThaiBHOptions,
  trangThaiPKOptions,
} from "assets/constants/select-catagory-options";
import {Button} from "antd";
import {PlusWhiteSVG} from "assets";
import dayjs from "dayjs";
import {birthday2Age} from "helper/common";
import KCBTypeColumn from "components/common/ColumnColors/KCBTypeColumn/KCBTypeColumn";
import {loaiBNOptions} from "assets/constants/kbnt-category";
import PatientTypeColumn from "components/common/ColumnColors/KCBTypeColumn/PatientTypeColumn";
import ColorStatus from "./components/ColorStatus/ColorStatus";
import BHYTColorStatus from "./components/BHYTStatusColor/BHYTStatusColor";
import ObjectTypeColumn from "components/common/ColumnColors/KCBTypeColumn/ObjectTypeColumn";
import KCBStatusColumn from "components/common/ColumnColors/KCBTypeColumn/KCBStatusColumn";
import {ColumnsEdit} from "types/models/column-table-edit";
import KCBAreaColumn from "components/common/ColumnColors/KCBTypeColumn/KCBAreaColumn";

const {INPUT, SELECT, DATE, CHECKBOX, COMBO_BOX} = FIELD_TYPE;

const NewPatientBtn = (handleFunc: any) => {
  return (
    <Button
      className="btn-sub"
      type="text"
      icon={<PlusWhiteSVG />}
      onClick={handleFunc}
    >
      Bệnh nhân mới
    </Button>
  );
};

const NewExamBillBtn = handleFunc => {
  return (
    <Button
      className="btn-sub"
      type="text"
      icon={<PlusWhiteSVG />}
      onClick={e => handleFunc()}
    >
      Phiếu khám mới
    </Button>
  );
};

const dataFields = (onOpenChange?) => {
  const dataFields: DataFormField[] = [
    {
      type: INPUT,
      label: "Mã bệnh nhân",
      expand: false,
      name: "maBenhNhan",
    },
    {
      type: INPUT,
      label: "Họ tên",
      expand: false,
      name: "hoTen",
    },
    {
      type: DATE,
      label: "Ngày sinh",
      expand: false,
      name: "ngaySinh",
      onOpenChange: onOpenChange,
    },
    {
      type: INPUT,
      label: "Số điện thoại",
      expand: false,
      name: "soDienThoai",
    },
    {
      type: INPUT,
      label: "Mã phiếu khám",
      expand: false,
      name: "id",
    },
    {
      type: SELECT,
      label: "Giới tính",
      expand: true,
      name: "gioiTinh",
      options: gioiTinhOptions,
    },
    {
      type: COMBO_BOX,
      label: "Tỉnh",
      expand: true,
      name: "tinh",
      options: JSON.parse(localStorage.getItem("listCommueNew")),
    },
    {
      type: COMBO_BOX,
      label: "Huyện",
      expand: true,
      name: "huyen",
    },
    {
      type: COMBO_BOX,
      label: "Xã",
      expand: true,
      name: "xa",
    },
    {
      type: INPUT,
      label: "Địa chỉ",
      expand: false,
      name: "diaChi",
    },
    {
      type: INPUT,
      label: "Số thẻ BHYT",
      expand: true,
      name: "soTheBHYT",
    },
    {
      type: INPUT,
      label: "Họ tên NV",
      expand: true,
      name: "tenNhanVien",
    },
    {
      type: COMBO_BOX,
      label: "Trạng thái BH",
      name: "trangThaiBH",
      expand: true,
      options: JSON.parse(localStorage.getItem("TTBH")),
    },
    {
      type: SELECT,
      label: "Loại KCB",
      expand: true,
      name: "loaiKCB",
      options: JSON.parse(localStorage.getItem("loaiKCB")),
    },
    {
      type: DATE,
      label: "Ngày tạo từ",
      expand: false,
      disableDate: false,
      name: "ngayTaoTu",
    },
    {
      type: DATE,
      label: "Ngày tạo đến",
      disableDate: false,
      expand: false,
      name: "ngayTaoDen",
    },
    {
      type: SELECT,
      label: "Trạng thái KCB",
      name: "trangThaiPK",
      expand: true,
      options: trangThaiPKOptions,
    },
    {
      type: SELECT,
      label: "Khu khám",
      name: "khuKCB",
      options: JSON.parse(localStorage.getItem("khuKham")),
      expand: true,
    },
  ];

  return dataFields;
};

const allColumns: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "STT",
    show: true,
    align: "center",
    isResizable: true,
    fixed: "left",
  },
  {
    title: "Mã bệnh nhân",
    dataIndex: "maBenhNhan",
    show: true,
    align: "center",
    render: (v, r, i) => (v ? String(v).toUpperCase() : ""),
    isResizable: true,
  },
  {
    title: "Mã phiếu khám",
    dataIndex: "id",
    show: true,
    align: "center",
    isResizable: true,
    // default: true,
    // render: (v, r, i) => v ? String(v).toUpperCase(): '',
  },
  {
    title: "Tên BN",
    dataIndex: "hoTen",
    show: true,
    align: "left",
    default: true,
    isResizable: true,
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    show: true,
    default: true,
    align: "left",
    isResizable: true,
    render: (v, r, i) =>
      gioiTinhOptions.find(it => it.value === v)?.label || "",
  },
  {
    title: "Ngày sinh",
    dataIndex: "ngaySinh",
    align: "center",
    show: true,
    render: (v, r, idx) => {
      return v ? <>{dayjs(v).format("DD/MM/YYYY")}</> : null;
    },
    isResizable: true,
  },
  {
    title: "Tuổi",
    dataIndex: "tuoi",
    align: "center",
    show: true,
    default: true,
    render: (v, r: any, i) => (r.ngaySinh ? birthday2Age(r.ngaySinh) : null),
    isResizable: true,
  },
  {
    title: "SĐT",
    dataIndex: "dienThoai",
    align: "right",
    show: true,
    default: true,
    isResizable: true,
  },
  {
    title: "Ngày nhập viện",
    dataIndex: "ngayNhapVien",
    show: true,
    align: "center",
    render: (v, r, idx) => {
      return v ? <>{dayjs(v).format("HH:mm DD/MM/YYYY")}</> : null;
    },
    isResizable: true,
  },
  {
    title: "Số thẻ BHYT",
    dataIndex: "maTheBhyt",
    show: true,
    render: (v, r, i) => (v ? String(v).toUpperCase() : ""),
    align: "center",
    isResizable: true,
  },
  {
    title: "Địa chỉ",
    dataIndex: "diaChiTongHop",
    key: "diaChiTongHop",
    show: true,
    isResizable: true,
  },
  {
    title: "Phòng",
    dataIndex: "phong",
    key: "phong",
    show: true,
    isResizable: true,
    render: text =>
      JSON.parse(localStorage.getItem("phongKhamNoPeople")).find(
        option => option?.value === text
      )?.label || "",
  },
  {
    title: "Loại KCB",
    dataIndex: "loaiKcb",
    show: true,
    default: true,
    align: "center",
    isResizable: true,
    render: text => {
      const ten =
        JSON.parse(localStorage.getItem("loaiKCB")).find(
          option => option.value === text
        )?.label || "";
      return <KCBTypeColumn label={ten} />;
    },
  },
  {
    title: "Loại bệnh nhân",
    dataIndex: "loaiBenhNhans",
    show: true,
    align: "center",
    render: text => {
      const loaiBN =
        loaiBNOptions.find(option => option.value === text?.[0])?.label || "";
      return <PatientTypeColumn label={loaiBN} />;
    },
    isResizable: true,
  },
  {
    title: "Nguồn bệnh nhân",
    dataIndex: "nguonBn",
    show: true,
    align: "left",
    isResizable: true,
  },
  {
    title: "Tên đoàn",
    dataIndex: "tenDoan",
    align: "left",
    show: true,
    isResizable: true,
  },
  {
    title: "Tên NV",
    dataIndex: "nhanVienTiepNhan",
    show: false,
    isResizable: true,
  },
  {
    title: "Trạng thái KCB",
    dataIndex: "trangThai",
    show: true,
    default: true,
    align: "center",
    render: text => {
      const ten =
        JSON.parse(localStorage.getItem("TTPhieu")).find(
          option => option.value === text
        )?.label || "";
      return <KCBStatusColumn label={ten} />;
    },
    isResizable: true,
  },
  {
    title: "Trạng thái BHYT",
    dataIndex: "trangThaiBH",
    align: "center",
    show: false,
    render: (v, r, idx) => {
      return <BHYTColorStatus value={v} />;
    },
    isResizable: true,
  },
  {
    title: "Khu KCB",
    dataIndex: "khuKCB",
    show: true,
    align: "left",
    isResizable: true,
    render: text => {
      const ten =
        JSON.parse(localStorage.getItem("khuKham")).find(
          option => option.value === text
        )?.label || "";
      return <KCBAreaColumn label={ten} />;
    },
  },
  {
    title: "Đối tượng",
    dataIndex: "doiTuong",
    show: true,
    align: "center",
    render: text => {
      const ten =
        JSON.parse(localStorage.getItem("doiTuong")).find(
          option => option.value === text
        )?.label || "";
      return <ObjectTypeColumn label={ten} />;
    },
    isResizable: true,
  },
  {
    title: "Thao tác",
    dataIndex: "Action",
    show: true,
    align: "center",
    fixed: "right",
    default: true,
    width: "2%",
  },
];

export {dataFields, NewExamBillBtn, NewPatientBtn, allColumns};
